const htmlTemplateForm = () => {
    const calculatorWrp = document.getElementById('calculator-mortgage-payment');

    if (!calculatorWrp) {
        return false;
    }

    const html = `<form id="mortgagePaymentCalculator" name="calc" class="calc-wrp">
        <div class="calc-wrp__container">
            <div class="calculator">
                <div class="calculator__fields">
                    <div class="calculator__form">
                        <div id="calculator" class="form-wrp" aria-label="Calculator">

                            <div class="form-wrp__layout">
                                <!--                            Home price, $-->
                                <div class="form-wrp__item">
                                    <label for="home-price" class="label">Home price, $</label>
                                    <input type="number"
                                           class="input"
                                           maxlength="256"
                                           name="home-price"
                                           placeholder="300000"
                                           value="300000"
                                           min="0"
                                           step="1000"
                                           id="home-price">
                                </div>
                                <!--                            Loan term, year-->
                                <div class="form-wrp__item">
                                    <label class="label">Loan term, year</label>
                                    <div class="form-wrp__radiobuttons">
                                        <label class="radio" for="10">
                                            <input type="radio"
                                                   name="term"
                                                   id="10"
                                                   value="10">
                                            <div class="radio__icon"></div>
                                            <span class="radio__label">10</span>
                                        </label>

                                        <label class="radio" for="15">
                                            <input type="radio"
                                                   name="term"
                                                   id="15"
                                                   value="15">
                                            <div class="radio__icon"></div>
                                            <span class="radio__label">15</span>
                                        </label>

                                        <label class="radio" for="20">
                                            <input type="radio"
                                                   name="term"
                                                   id="20"
                                                   value="20">
                                            <div class="radio__icon"></div>
                                            <span class="radio__label">20</span>
                                        </label>

                                        <label class="radio" for="25">
                                            <input type="radio"
                                                   name="term"
                                                   id="25"
                                                   value="25">
                                            <div class="radio__icon"></div>
                                            <span class="radio__label">25</span>
                                        </label>

                                        <label class="radio" for="30">
                                            <input type="radio"
                                                   name="term"
                                                   id="30"
                                                   value="30"
                                                   checked>
                                            <div class="radio__icon"></div>
                                            <span class="radio__label">30</span>
                                        </label>
                                    </div>
                                </div>
                                <!--                            Down payment, $-->
                                <div class="form-wrp__item condition-item">
                                    <div class="switcher-parent">
                                        <label class="switcher-label" for="switch-down-payment-currency">
                                            <input type="radio" name="switch-down-payment" value="$" class="switcher" id="switch-down-payment-currency" checked="checked">
                                            <div class="radio-icon">$</div>
                                        </label>
                                        <label class="switcher-label" for="switch-down-payment-percent">
                                            <input type="radio" name="switch-down-payment" value="%" class="switcher" id="switch-down-payment-percent">
                                            <div class="radio-icon">%</div>
                                        </label>
                                    </div>
                                    <label for="down-payment" class="label">Down payment</label>
                                    <input type="number"
                                           class="input"
                                           maxlength="256"
                                           name="down-payment"
                                           placeholder="30000"
                                           value="30000"
                                           min="0"
                                           step="1000"
                                           id="down-payment">
                                </div>
                                <!--                            Interest Rate, %-->
                                <div class="form-wrp__item condition-item">
                                    <label for="interest-rate" class="label">Interest Rate, %</label>
                                    <input type="number"
                                           class="input"
                                           name="interest-rate"
                                           id="interest-rate"
                                           step="0.125"
                                           min="0"
                                           value="5.75">
                                </div>
                                <!--                        Checkbox Include -->
                                <div class="form-wrp__item">
                                    <label class="checkbox checkbox-inline" for="tax-switch">
                                        <input type="checkbox"
                                               name="tax-switch"
                                               id="tax-switch"
                                               data-name="tax-switch"
                                               data-calc-exclude="property-tax">
                                        <div class="checkbox__icon"></div>
                                        <span class="checkbox__label">Principal & interest only</span>
                                    </label>
                                </div>
                                <!--                        Checkbox empty-->
                                <div class="form-wrp__item"></div>
                                <!--                        Home insurance (yearly), $-->
                                <div class="form-wrp__item">
                                    <div class="switcher-parent">
                                        <label class="switcher-label" for="switch-home-insurance-currency">
                                            <input type="radio" name="switch-home-insurance"
                                                   data-target="home-insurance"
                                                   value="$" class="switcher" id="switch-home-insurance-currency" checked="checked">
                                            <div class="radio-icon">$</div>
                                        </label>
                                        <label class="switcher-label" for="switch-home-insurance-percent">
                                            <input type="radio" name="switch-home-insurance"
                                                   data-target="property-tax"
                                                   value="%" class="switcher" id="switch-home-insurance-percent">
                                            <div class="radio-icon">%</div>
                                        </label>
                                    </div>
                                    <label for="home-insurance" class="label">Home insurance (yearly)</label>
                                    <input type="number"
                                           class="input"
                                           name="home-insurance"
                                           id="home-insurance"
                                           min="0"
                                           step="100"
                                           value="2000">
                                </div>
                                <!--                        Property tax (yearly), $-->
                                <div class="form-wrp__item" data-property-tax>
                                    <div class="switcher-parent">
                                        <label class="switcher-label" for="switch-property-currency">
                                            <input type="radio" name="switch-property"
                                                   data-target="property-tax"
                                                   value="$" class="switcher" id="switch-property-currency" checked="checked">
                                            <div class="radio-icon">$</div>
                                        </label>
                                        <label class="switcher-label" for="switch-property-percent">
                                            <input type="radio" name="switch-property"
                                                   data-target="property-tax"
                                                   value="%" class="switcher" id="switch-property-percent">
                                            <div class="radio-icon">%</div>
                                        </label>
                                    </div>
                                    <label for="property-tax" class="label">Property taxes (yearly)</label>
                                    <input type="number"
                                           class="input"
                                           name="property-tax"
                                           placeholder="0"
                                           value="7500"
                                           step="1000"
                                           min="0"
                                           id="property-tax">
                                </div>
                                <!--                        Checkbox Include -->
<!--                                <div class="form-wrp__item">-->
<!--                                    <label class="checkbox checkbox-inline" for="additional-switch">-->
<!--                                        <input type="checkbox"-->
<!--                                               name="additional-switch"-->
<!--                                               class="switcher"-->
<!--                                               id="additional-switch"-->
<!--                                               checked="checked"-->
<!--                                               data-calc-exclude="additional-insurance">-->
<!--                                        <div class="checkbox__icon"></div>-->
<!--                                        <span class="checkbox__label">Include Additional Insurance</span>-->
<!--                                    </label>-->
<!--                                    <label class="checkbox checkbox-inline" for="pmi-switch">-->
<!--                                        <input type="checkbox"-->
<!--                                               name="pmi-switch"-->
<!--                                               class="switcher"-->
<!--                                               id="pmi-switch"-->
<!--                                               checked="checked"-->
<!--                                               data-calc-exclude="pmi-rate">-->
<!--                                        <div class="checkbox__icon"></div>-->
<!--                                        <span class="checkbox__label">Include MI</span>-->
<!--                                    </label>-->
<!--                                </div>-->
                                <!--                        Checkbox empty-->
<!--                                <div class="form-wrp__item"></div>-->

                                <!--                        PMI rate-->
                                <div class="form-wrp__item" data-property-tax>
                                    <div class="switcher-parent">
                                        <label class="switcher-label" for="switch-mortgage-currency">
                                            <input type="radio" name="switch-mortgage" value="$" class="switcher" id="switch-mortgage-currency">
                                            <div class="radio-icon">$</div>
                                        </label>
                                        <label class="switcher-label" for="switch-mortgage-percent">
                                            <input type="radio" name="switch-mortgage" value="%" class="switcher" id="switch-mortgage-percent" checked="checked">
                                            <div class="radio-icon">%</div>
                                        </label>
                                    </div>
                                    <label for="pmi-rate" class="label">Mortgage insurance, (yr)</label>
                                    <input type="number"
                                           class="input"
                                           name="pmi-rate"
                                           placeholder="0.5"
                                           step="0.125"
                                           value="0.5"
                                           min="0"
                                           id="pmi-rate">
                                </div>

                                <!--                        Additional Insurance-->
<!--                                <div class="form-wrp__item" data-additional-insurance>-->
<!--                                    <div class="switcher-parent">-->
<!--                                        <label class="switcher-label" for="switch-additional-currency">-->
<!--                                            <input type="radio" name="switch-additional" value="$" class="switcher" id="switch-additional-currency" checked="checked">-->
<!--                                            <div class="radio-icon">$</div>-->
<!--                                        </label>-->
<!--                                        <label class="switcher-label" for="switch-additional-percent">-->
<!--                                            <input type="radio" name="switch-additional" value="%" class="switcher" id="switch-additional-percent">-->
<!--                                            <div class="radio-icon">%</div>-->
<!--                                        </label>-->
<!--                                    </div>-->
<!--                                    <label for="additional-insurance" class="label full">More Insurance (yearly)</label>-->
<!--                                    <input type="number"-->
<!--                                           class="input"-->
<!--                                           name="additional-insurance"-->
<!--                                           placeholder="0"-->
<!--                                           value="0"-->
<!--                                           step="0.125"-->
<!--                                           min="0"-->
<!--                                           id="additional-insurance">-->
<!--                                </div>-->

                                <!--                        HOA dues, $-->
                                <div class="form-wrp__item">
                                    <label for="hoa-dues" class="label">HOA dues (monthly)</label>
                                    <input type="number"
                                           class="input"
                                           name="hoa-dues"
                                           placeholder="0"
                                           value="0"
                                           min="0"
                                           step="1"
                                           id="hoa-dues">
                                </div>
                            </div>
                            <div class="calc-wrp__btn-box">
                                <button id="rerender" type="button" class="calc-wrp__btn-calc">
                                    Prequalify Now
                                    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                                <button type="button" class="calc-wrp__btn-calc secondary" data-modal="modalSendResult">
                                    Send now
                                    <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="calculator__graphics">

                    <div class="calculator__prices">
                        <div class="calculator__price">
                            <div class="calculator__price-label">Mortgage Amount</div>
                            <div class="calculator__price-number" data-calc-result="amount"></div>
                        </div>
                        <div class="calculator__price">
                            <div class="calculator__price-label">Total Cost Of Mortgage</div>
                            <div class="calculator__price-number" data-calc-result="total"></div>
                        </div>
                    </div>

                    <div class="chart">
                        <div class="chart__donut">

                            <div class="chart__text">
                                <div class="chart__description">Estimated Monthly payment:</div>
                                <div class="chart__price">
                                    <span data-calc-result="monthly"></span>
                                </div>
                            </div>

                            <div class="chart__donut-wrp">
                                <canvas id="donutBox" data-calc="donut" width="400" height="400"></canvas>
                            </div>

                            <div class="legend">
                                <div class="legend__item">
                                    <div class="legend__color" data-calc-legend-name="P&amp;I"></div>
                                    <div class="legend__text">P&amp;I</div>
                                </div>
                                <div class="legend__item">
                                    <div class="legend__color" data-calc-legend-name="Insurance"></div>
                                    <div class="legend__text">Insurance</div>
                                </div>
                                <div class="legend__item">
                                    <div class="legend__color" data-calc-legend-name="Taxes"></div>
                                    <div class="legend__text">Taxes</div>
                                </div>
                                <div class="legend__item">
                                    <div class="legend__color" data-calc-legend-name="PMI"></div>
                                    <div class="legend__text">MI</div>
                                </div>
                                <div class="legend__item">
                                    <div class="legend__color" data-calc-legend-name="HOA"></div>
                                    <div class="legend__text">HOA</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!--                    modal-->
            <div class="modal" id="modalSendResult">
                <div class="modal__bg modal-exit"></div>
                <div class="modal__container">
                    <button class="modal__close modal-exit">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.00081 14L14 1.00081M1 1L13.9992 13.9992" stroke="#232323" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <h3 class="modal__title">Send me my results</h3>
                    <div class="modal__body">
                        <div class="form-send">
                            <div class="form-send__input-box">
                                <label for="email" class="form-send__label">Email address</label>
                                <input id="email" type="email" class="form-send__input" name="email" placeholder="Enter your email">
                            </div>

                            <div class="form-send__input-box">
                                <label for="name" class="form-send__label">Name</label>
                                <input id="name" type="text" class="form-send__input" name="name" placeholder="Enter your name">
                            </div>

                            <div class="form-send__input-box">
                                <label for="phone" class="form-send__label">Phone</label>
                                <input id="phone" type="tel" class="form-send__input" name="phone" placeholder="Enter your phone">
                            </div>
                        </div>
                        <div class="form-send__status-ok hide">Success!</div>
                        <div class="form-send__status-fail hide">Error!</div>
                        <button type="submit" 
                            class="calc-wrp__btn-calc" 
                            data-text="Prequalify Now" 
                            data-wait="Loading..." 
                            data-success="Success!" 
                            data-error="Error!">
                            Send now
                            <svg width="7" height="10" viewBox="0 0 7 10" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.31812 9L5.68175 5L1.31812 1" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>`;

    calculatorWrp.insertAdjacentHTML("afterbegin", html);

    return true;
};

export default htmlTemplateForm;